import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import "lazysizes";
import "lazysizes/plugins/unveilhooks/ls.unveilhooks";
import { FsLightbox } from "fslightbox";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	endlessPaginate({
		moreSelector: "span.endless_more",
		moreSelectorDataUrl: "data-more",
	});
});
